import React from 'react'

const RevertIcon = () => {
    return (
        <div>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M29.3035 24.8892C31.0613 22.2578 31.9998 19.1646 31.9998 16C31.9998 11.7563 30.3143 7.68701 27.3133 4.68652C24.3133 1.68555 20.243 0 15.9998 0C12.8358 0 9.74201 0.938477 7.11115 2.69629C4.47931 4.45459 2.42853 6.95361 1.21759 9.87695C0.00665569 12.8008 -0.309751 16.0176 0.307437 19.1216C0.924624 22.2251 2.44806 25.0762 4.68634 27.3135C6.92365 29.5513 9.77423 31.0752 12.8787 31.6924C15.9822 32.3101 19.199 31.9932 22.1229 30.7822C25.0467 29.5713 27.5457 27.5205 29.3035 24.8892ZM16.2664 10.3027V7L7.99982 12.7744L16.2664 18.5693V15.2041C20.9403 15.0176 22.8299 19.9814 18.8006 22.8477C18.4471 23.0972 18.0945 23.3462 17.658 23.5747C17.658 23.5747 10.368 26.7109 18.5926 23.6787C19.3201 23.3672 20.0047 22.9932 20.6492 22.5361C26.5272 18.2783 23.4735 10.2402 16.2664 10.3027Z" fill="#475969" />
            </svg>
        </div>
    )
}

export default RevertIcon

